class CookieConsent extends HTMLElement {
    constructor() {
        super();

        // Dohvaća status kolačića
        const cookieStatus = this.getCookie('cookie-consent');

        // Prikazuje banner ako kolačić ne postoji ili ako je odbijen prije više od 24 sata
        if (!cookieStatus || (cookieStatus === 'declined' && !this.isRecentDecline())) {
            this.style.display = "block";

            if (this.classList.contains('full-width')) {
                this.adjustPadding();
                window.addEventListener('resize', this.adjustPadding.bind(this));
            }
        } else {
            this.remove();
        }

        // Gumb "Prihvati kolačiće"
        const acceptButton = this.querySelector('[data-accept-cookie]');
        if (acceptButton) {
            acceptButton.addEventListener('click', this.acceptCookies.bind(this));
        }

        // Gumb "Odbij kolačiće"
        const declineButton = this.querySelector('[data-decline-cookie]');
        if (declineButton) {
            declineButton.addEventListener('click', this.declineCookies.bind(this));
        }
    }

    // Postavlja kolačić s određenim trajanjem
    setCookie(name, value, days) {
        let expires = "";
        if (days) {
            let date = new Date();
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + value + "; path=/; SameSite=Lax" + expires;
    }

    // Dohvaća vrijednost kolačića
    getCookie(name) {
        const nameEQ = name + "=";
        const cookies = document.cookie.split('; ');
        for (let cookie of cookies) {
            if (cookie.startsWith(nameEQ)) {
                return cookie.split('=')[1];
            }
        }
        return '';
    }

    // Briše kolačić
    deleteCookie(name) {
        document.cookie = name + "=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    }

    // Provjerava je li odbijanje kolačića bilo u posljednjih 24 sata
    isRecentDecline() {
        const declineTime = this.getCookie('cookie-declined-time');
        if (!declineTime) return false;

        const declineDate = new Date(parseInt(declineTime, 10));
        const now = new Date();

        // Ako je prošlo manje od 24 sata, vraća true (ne prikazuje banner)
        return (now - declineDate) < (24 * 60 * 60 * 1000);
    }

    // Prihvaćanje kolačića (pamti 1 godinu)
    acceptCookies(event) {
        event.preventDefault();
        this.setCookie('cookie-consent', 'accepted', 365);
        this.remove();

        if (this.classList.contains('full-width')) {
            document.body.style.paddingBottom = "0px";
        }
    }

    // Odbijanje kolačića (pamti 24 sata, briše tracking kolačiće)
    declineCookies(event) {
        event.preventDefault();

        // Postavlja oznaku da je korisnik odbio kolačiće
        this.setCookie('cookie-consent', 'declined', 1);
        this.setCookie('cookie-declined-time', Date.now(), 1); // Bilježi vrijeme odbijanja

        this.remove();

        // Briše sve ne-esencijalne kolačiće (Google Analytics, Facebook Pixel, Shopify tracking itd.)
        this.deleteCookie('_ga');  
        this.deleteCookie('_gid'); 
        this.deleteCookie('_fbp'); 
        this.deleteCookie('_gat'); 
        this.deleteCookie('_shopify_y'); 
        this.deleteCookie('_shopify_s'); 

        if (this.classList.contains('full-width')) {
            document.body.style.paddingBottom = "0px";
        }
    }

    // Automatsko podešavanje paddinga ako je full-width banner
    adjustPadding() {
        const cookieHeight = this.offsetHeight;
        if (cookieHeight > 0) {
            document.body.style.paddingBottom = `${cookieHeight}px`;
        }
    }
}

customElements.define('cookie-consent', CookieConsent);